import React from 'react'
import useFetch from './useFetch'

const useEmbeddedList = (fn, params = {}, observable = []) => {
  const [page, setPage] = React.useState(params.page || 1)
  const [perPage, setPerPage] = React.useState(params.perPage || 20)
  const resource = useFetch(
    fn,
    { ...params, page, perPage },
    observable.concat([page, perPage]),
  )

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1)
  }

  const handleChangeRowsPerPage = event => {
    setPerPage(parseInt(event.target.value, 10))
  }

  return {
    pagination: { handleChangeRowsPerPage, handleChangePage, page, perPage },
    ...resource,
  }
}

export default useEmbeddedList
